// TransliterateModal.tsx
import { Button, Modal, Radio, Checkbox, Alert } from "antd";
import React, { useState } from "react";
import styled from "styled-components";

const TransliterateModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  .language-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 20px;
  }
  
  .inventory-type-section {
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 16px;
    background-color: #fafafa;
  }
  
  .section-title {
    font-weight: 600;
    font-size: 14px;
    color: #262626;
    margin-bottom: 12px;
  }
  
  .checkbox-group {
    display: flex;
    gap: 8px;
  }
  
  .info-text {
    color: #666;
    font-size: 14px;
  }
`;

interface TransliterateModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: (inventoryTypes: string[]) => void;
  availableLanguages: string[];
  selectedLanguage: string;
  setSelectedLanguage: (language: string) => void;
}

const TransliterateModal: React.FC<TransliterateModalProps> = ({
  visible,
  onCancel,
  onOk,
  availableLanguages,
  selectedLanguage,
  setSelectedLanguage,
}) => {
  const [selectedPackage, setSelectedPackage] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState(false);

  const getLanguageDisplayName = (code: string) => {
    const languageMap: Record<string, string> = {
      'hi': 'Hindi',
      'en': 'English',
      'bn': 'Bengali',
      'ta': 'Tamil',
      'te': 'Telugu',
      'kn': 'Kannada',
    };
    return languageMap[code] || code;
  };

  const handleOk = () => {
    if (!selectedPackage && !selectedAddons) {
      return; // Don't proceed if no inventory type is selected
    }

    const inventoryTypes: string[] = [];
    if (selectedPackage) inventoryTypes.push('pooja');
    if (selectedAddons) inventoryTypes.push('item');

    onOk(inventoryTypes);
  };

  const isValid = selectedPackage || selectedAddons;

  return (
    <Modal
      title="Transliterate Name & Gotra"
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      width={500}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleOk}
          disabled={!isValid}
        >
          Continue
        </Button>,
      ]}
    >
      <TransliterateModalContent>
        <div className="info-text">
          Select a language to transliterate the current inventory. This process may take a few minutes.
        </div>
        <div className="inventory-type-section">
          <div className="section-title">Select Inventory Type</div>
          <div className="checkbox-group">
            <Checkbox
              checked={selectedPackage}
              onChange={(e) => setSelectedPackage(e.target.checked)}
            >
              Package
            </Checkbox>
            <Checkbox
              checked={selectedAddons}
              onChange={(e) => setSelectedAddons(e.target.checked)}
            >
              Addons
            </Checkbox>
          </div>
          {!isValid && (
            <Alert
              message="Please select at least one inventory type"
              type="warning"
              showIcon
              style={{ marginTop: 12 }}
            />
          )}
        </div>

        <div className="language-options">
          {availableLanguages.map(language => (
            <Radio
              key={language}
              value={language}
              checked={selectedLanguage === language}
              onChange={() => setSelectedLanguage(language)}
            >
              {getLanguageDisplayName(language)}
            </Radio>
          ))}
        </div>


      </TransliterateModalContent>
    </Modal>
  );
};

export default TransliterateModal;